module.exports = __webpack_public_path__ + "img/how-it-works-promoters-2.8de498ed.png";